import React from "react";
import { Palette } from "./holidayConfig";

/*
 * Ljus och atmosfär – lagren som ger scenerna djup. Scenerna placerar
 * själva ut delarna i rätt ordning mellan himmel och landskap.
 */

/** Ljuskälla bakom innehållet. */
export const Glow: React.FC<{ p: Palette }> = ({ p }) => (
  <div
    className="hol-glow"
    style={{
      background: `radial-gradient(ellipse 60% 55% at 50% 38%, ${p[800]} 0%, ${p[900]}88 40%, transparent 72%)`,
    }}
  />
);

/** Norrsken som skimrar över himlen. */
export const Aurora: React.FC<{ p: Palette }> = ({ p }) => (
  <div className="hol-aurora">
    <div className="hol-aurora-band" style={{ background: `linear-gradient(90deg, transparent, ${p[300]}55 30%, #ffffff66 50%, ${p[200]}55 70%, transparent)` }} />
    <div className="hol-aurora-band" style={{ top: "18%", animationDelay: "-7s", animationDuration: "26s", background: `linear-gradient(90deg, transparent, #ffffff44 35%, ${p[300]}66 55%, transparent)` }} />
    <div className="hol-aurora-band" style={{ top: "30%", animationDelay: "-13s", animationDuration: "31s", opacity: 0.6, background: `linear-gradient(90deg, transparent, ${p[200]}55 40%, #ffffff55 60%, transparent)` }} />
  </div>
);

/** Blixt som lyser upp himlen då och då. */
export const Lightning: React.FC = () => (
  <>
    <div className="hol-lightning" />
    <div className="hol-lightning" style={{ animationDelay: "-9s", animationDuration: "23s" }} />
  </>
);

/** Solstrålar som roterar långsamt. */
export const Rays: React.FC<{ right?: string; left?: string; top?: string; color?: string }> = ({
  right,
  left,
  top,
  color = "rgba(255,255,255,0.07)",
}) => (
  <div
    className="hol-rays"
    style={{
      right,
      left,
      top,
      background: `repeating-conic-gradient(from 0deg, ${color} 0deg 5deg, transparent 5deg 16deg)`,
    }}
  />
);

/** Vinjett för djup – ligger överst i bakgrundslagret. */
export const Vignette: React.FC<{ strength?: number }> = ({ strength = 0.38 }) => (
  <div
    className="hol-vignette"
    style={{ background: `radial-gradient(ellipse 85% 75% at 50% 45%, transparent 50%, rgba(0, 0, 0, ${strength}) 100%)` }}
  />
);
